import React from 'react';
import { CheckIcon, ChevronDownIcon, PackageIcon, ThermometerIcon, SlackIcon, FanIcon } from 'lucide-react';
export const ScenarioSelector = ({
  scenarios,
  selectedScenario,
  setSelectedScenario,
  showComparison,
  setShowComparison,
  formatPrice,
  showVat
}) => {
  const handleSelectScenario = scenario => {
    setSelectedScenario(scenario);
  };
  const getVatAdjustedPrice = price => {
    return showVat ? price : Math.round(price / 1.25);
  };
  return <section className="space-y-4" data-id="element-142">
      <div className="flex justify-between items-center" data-id="element-143">
        <h2 className="text-xl font-bold text-gray-800" data-id="element-144">Vælg din løsning</h2>
        <button className="text-sm text-red-600 hover:underline flex items-center" onClick={() => setShowComparison(!showComparison)} data-id="element-145">
          {showComparison ? 'Skjul sammenligning' : 'Sammenlign scenarier side-om-side'}
          <ChevronDownIcon className={`ml-1 h-4 w-4 transition-transform ${showComparison ? 'rotate-180' : ''}`} data-id="element-146" />
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-147">
        {Object.keys(scenarios).map(key => {
        const scenario = scenarios[key];
        const isSelected = selectedScenario === key;
        return <div key={key} className={`bg-white rounded-lg shadow-md overflow-hidden border-2 transition-all ${isSelected ? 'border-red-500 ring-2 ring-red-100' : 'border-transparent hover:border-gray-200'}`} data-id="element-148">
              <div className="p-6 space-y-4" data-id="element-149">
                <div className="flex justify-between items-start" data-id="element-150">
                  <div data-id="element-151">
                    <span className="px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800" data-id="element-152">
                      {scenario.badge}
                    </span>
                    <h3 className="mt-2 text-lg font-bold text-gray-800" data-id="element-153">
                      {scenario.name}
                    </h3>
                  </div>
                  {isSelected && <span className="bg-red-500 rounded-full p-1" data-id="element-154">
                      <CheckIcon className="h-4 w-4 text-white" data-id="element-155" />
                    </span>}
                </div>
                <div className="space-y-1" data-id="element-156">
                  <div className="text-2xl font-bold text-gray-900" data-id="element-157">
                    {formatPrice(getVatAdjustedPrice(scenario.basePrice))}
                  </div>
                  <div className="text-sm text-gray-500" data-id="element-158">
                    Fra {formatPrice(scenario.monthlyPayment)}/md
                  </div>
                </div>
                <div className="flex items-center gap-2 text-sm" data-id="element-159">
                  <span className={`px-2 py-0.5 rounded-full ${scenario.stock === 'På lager' ? 'bg-green-100 text-green-800' : scenario.stock === 'Delvist på lager' ? 'bg-yellow-100 text-yellow-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-160">
                    {scenario.stock}
                  </span>
                  <span className="text-gray-600" data-id="element-161">• ETA: {scenario.eta}</span>
                </div>
                <ul className="space-y-2 text-sm text-gray-600" data-id="element-162">
                  <li className="flex items-start gap-2" data-id="element-163">
                    <PackageIcon className="h-4 w-4 text-gray-400 mt-0.5" data-id="element-164" />
                    <span data-id="element-165">{scenario.manifold}</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-166">
                    <div className="h-4 w-4 text-gray-400 mt-0.5" data-id="element-167" />
                    <span data-id="element-168">{scenario.pipes}</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-169">
                    <ThermometerIcon className="h-4 w-4 text-gray-400 mt-0.5" data-id="element-170" />
                    <span data-id="element-171">{scenario.thermostats}</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-172">
                    <SlackIcon className="h-4 w-4 text-gray-400 mt-0.5" data-id="element-173" />
                    <span data-id="element-174">{scenario.pump}</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-175">
                    <FanIcon className="h-4 w-4 text-gray-400 mt-0.5" data-id="element-176" />
                    <span data-id="element-177">{scenario.ventilation}</span>
                  </li>
                </ul>
                <button onClick={() => handleSelectScenario(key)} className={`w-full py-2 px-4 rounded-md font-medium ${isSelected ? 'bg-red-600 text-white hover:bg-red-700' : 'bg-gray-100 text-gray-800 hover:bg-gray-200'}`} data-id="element-178">
                  {isSelected ? 'Valgt løsning' : 'Vælg denne løsning'}
                </button>
              </div>
            </div>;
      })}
      </div>
    </section>;
};